import { FeatureMainProps } from '../../../../components/Features/FeatureMain/types'

export const pageData: FeatureMainProps = {
    accentColor: '#B39149',
    pc: {
        background: '/features/tokyu-rs-20261014/pc_bg.jpg',
        overlay: 'rgba(3, 34, 10, 0.85)',
        eyebrow: '求人特集',
        titleLines: ['東急リゾーツ', '&ステイ'],
        contentsColor: '#030D22',
    },
    hero: {
        image: '/features/tokyu-rs-20261014/hero.jpg',
        alt: '求人特集 東急リゾーツ&ステイ TOKYU RESORTS & STAYS 2027年、新たなリゾートの舞台「草津」へ ともにホテルをつくる仲間を募集',
        analyticsLabel: 'FV',
    },
    headline: {
        title: [
            { text: 'また訪れたい', accent: true },
            { text: 'を' },
            { text: '積み重ねていく。', breakBefore: true },
        ],
        paragraphs: [
            { text: '2027年、草津に新たなリゾートホテルが誕生。' },
            {
                text: 'まだ何もないところからホテルの歴史をつくる、',
                breakBefore: true,
            },
            { text: '新しい「楽しい」を生み出す、', breakBefore: true },
            { text: 'オープニングメンバーを募集します。', breakBefore: true },
        ],
    },
    thumbnail: {
        image: '/features/tokyu-rs-20261014/top_sub.jpg',
        alt: '店内、配膳するスタッフ、デザートを盛り付ける様子の3枚の写真',
    },
    featuresTitle: ['東急リゾーツ&ステイで働く魅力'],
    featuresTitleAnalyticsLabel: 'CT_Charm_働く魅力-タイトル',
    features: [
        {
            heading: ['東急ブランドの信頼と、', '長年培ってきたホテル運営力'],
            body: [
                '東急リゾーツ＆ステイは、東急不動産ホールディングスグループの一員。全国100を超える施設を運営し、長年のリゾート運営で培ったノウハウを持っています。',
            ],
            image: '/features/tokyu-rs-20261014/section_01.jpg',
            analyticsLabel: 'CT_Charm_働く魅力-1st',
        },
        {
            heading: ['一つひとつのホテルで、', '“ここにしかないおもてなし”'],
            body: [
                '東急リゾーツ＆ステイは、ホテルごとに地域やブランドの個性を活かした宿泊体験を提供。各ホテルの個性を活かし、「31施設あれば31通りのオリジナルホテル」を追求しています。',
            ],
            image: '/features/tokyu-rs-20261014/section_02.jpg',
            analyticsLabel: 'CT_Charm_働く魅力-2nd',
        },
        {
            heading: [
                '2027年、',
                '新たなホテルが誕生、',
                '“これから”のホテルを',
                'つくるチャンス',
            ],
            body: [
                '2027年3月には「東急ハーヴェストクラブ草津＆VIALA」が開業予定。新しいホテルの歴史を、ゼロからつくるチャンスがあります。',
            ],
            image: '/features/tokyu-rs-20261014/section_03.jpg',
            analyticsLabel: 'CT_Charm_働く魅力-3rd',
        },
    ],
    jobs: {
        eyebrow: 'pickup',
        title: ['東急リゾーツ&ステイ 求人特集'],
        analyticsLabel: 'CT_Jobinformation_求人特集-タイトル',
        categories: [
            {
                id: 'harvest-kusatsu',
                categoryLabel: '東急ハーヴェストクラブ草津&VIALA',
                variant: 'list',
                description:
                    '東急不動産が展開する会員制リゾートホテル“自然を想い、地域と、訪れる人とともに。”をコンセプトに上質なサービスを追求できます',
                jobs: [
                    {
                        offerId: '114710',
                        badgeLabel: '調理部門｜キッチンスタッフ',
                        title: '【草津に新規開業×安定の東急G】調理募集＊福利厚生・労働環境◎＊転居補助',
                        brandName: '東急ハーヴェストクラブ草津&VIALA',
                        brandLogo: '/features/tokyu-rs-20261014/logo_01.png',
                        salary: '335~570',
                        salaryUnit: '年収',
                        prefecture: '群馬県',
                        city: '吾妻郡草津町',
                        image: '/features/tokyu-rs-20261014/job_card_01_01.jpg',
                        href: 'https://hotel.foods-labo.com/offers/114710',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-東急ハーヴェストクラブ草津&VIALA-1st',
                    },
                    {
                        offerId: '114709',
                        badgeLabel:
                            '料飲部門｜レストランサービス・ホールスタッフ',
                        title: '【新規開業の会員制リゾートホテル】安心の東急グループ＊福利厚生充実＊賞与有',
                        brandName: '東急ハーヴェストクラブ草津&VIALA',
                        brandLogo: '/features/tokyu-rs-20261014/logo_01.png',
                        salary: '335~570',
                        salaryUnit: '年収',
                        prefecture: '群馬県',
                        city: '吾妻郡草津町',
                        image: '/features/tokyu-rs-20261014/job_card_01_02.jpg',
                        href: 'https://hotel.foods-labo.com/offers/114709',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-東急ハーヴェストクラブ草津&VIALA-2nd',
                    },
                    {
                        offerId: '122546',
                        badgeLabel: '調理部門｜パティシエ',
                        title: '【パティシエ即戦力を募集】27年開業＊転居補助＊東急グループ＊労働環境安定',
                        brandName: '東急ハーヴェストクラブ草津&VIALA',
                        brandLogo: '/features/tokyu-rs-20261014/logo_01.png',
                        salary: '335~570',
                        salaryUnit: '年収',
                        prefecture: '群馬県',
                        city: '吾妻郡草津町',
                        image: '/features/tokyu-rs-20261014/job_card_01_03.jpg',
                        href: 'https://hotel.foods-labo.com/offers/122546',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-東急ハーヴェストクラブ草津&VIALA-3rd',
                    },
                    {
                        offerId: '122548',
                        badgeLabel: '調理部門｜ブーランジェ・ベーカー',
                        title: '【ブーランジェ募集｜オールスクラッチ】転居補助＊東急グループ＊労働環境安定',
                        brandName: '東急ハーヴェストクラブ草津&VIALA',
                        brandLogo: '/features/tokyu-rs-20261014/logo_01.png',
                        salary: '335~570',
                        salaryUnit: '年収',
                        prefecture: '群馬県',
                        city: '吾妻郡草津町',
                        image: '/features/tokyu-rs-20261014/job_card_01_04.jpg',
                        href: 'https://hotel.foods-labo.com/offers/122548',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-東急ハーヴェストクラブ草津&VIALA-4th',
                    },
                    {
                        offerId: '122566',
                        badgeLabel: '管理部門｜施設管理全般',
                        title: '【施設管理スタッフ募集】安心の東急グループ＊福利厚生充実＊転居補助あり',
                        brandName: '東急ハーヴェストクラブ草津&VIALA',
                        brandLogo: '/features/tokyu-rs-20261014/logo_01.png',
                        salary: '335~570',
                        salaryUnit: '年収',
                        prefecture: '群馬県',
                        city: '吾妻郡草津町',
                        image: '/features/tokyu-rs-20261014/job_card_01_05.jpg',
                        href: 'https://hotel.foods-labo.com/offers/122566',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-東急ハーヴェストクラブ草津&VIALA-5th',
                    },
                ],
            },
        ],
    },
    floatingCta: {
        label: '求人一覧を見る',
        analyticsLabel: 'CT_Jobinformation_追従CTA',
    },
}
